import { z } from "zod";
import { FeedbackDepartmentEnum, FeedbackTypeEnum } from "@/types/feedback";
import type { ValidationT } from "../i18n";

export const makeFeedbackFormSchema = (t: ValidationT) =>
  z.object({
    rating: z
      .number()
      .min(0.5, t("ratingRequired"))
      .max(5)
      .refine((v) => (v * 10) % 5 === 0, t("ratingStep")),
    type: z.nativeEnum(FeedbackTypeEnum, {
      error: t("feedbackTypeRequired"),
    }),
    department: z.nativeEnum(FeedbackDepartmentEnum, {
      error: t("departmentRequired"),
    }),
    related_page: z.string().max(100).optional(),
    message: z.string().min(10, t("min10Chars")).max(5000, t("max5000Chars")),
  });

export type FeedbackFormValues = z.infer<
  ReturnType<typeof makeFeedbackFormSchema>
>;
